<template>
  <div class="icon-price">
    <img
      class="price-ico"
      :class="'price-ico-'+size"
      :src="priceType == 2 &&  app == 'ios' ? config.entity_price_ico : config.price_ico"
      alt
    />
  </div>
</template>

<script>
export default {
  name: "IconPirce",
  props: {
    size: {
      type: String,
      default: "max"
    },
    // 2 表示ios下的实物需要检测图标
    priceType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {};
  },
  computed: {
    config() {
      return this.$store.state.config;
    },
    app() {
      return this.$store.state.app;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.icon-price {
  display: inline-block;
  .price-ico-max {
    width: 24px;
  }
  .price-ico-middle {
    width: 20px;
  }
  .price-ico-mini {
    width: 16px;
  }
}
</style>
